<template>
  <card>
    <vue-element-loading
      :text="loading.text"
      spinner="bar-fade-scale"
      :color="loading.color"
      :active="loading.active"
      :is-full-screen="false"/>
    <div slot="header">
      <h4 class="title">Nuevo Dispositivo</h4>
    </div>
    <div>
      <form id="edit_form">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Marca"
                      placeholder="Marca del dispositivo"
                      v-model="device.brand"
                      >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Modelo"
                      placeholder="Modelo del dispositivo"
                      v-model="device.model"
                      >
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="ID del dispositivo"
                      placeholder="ID del dispositivo"
                      v-model="device.id_device"
                      v-validate="modelValidations.id"
                      :error="getError('device_id')"
                      name="device_id">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="MAC del dispositivo"
                      placeholder="00:00:00:00:00:00"
                      v-model="device.mac"
                      v-validate="modelValidations.mac"
                      :error="getError('mac')"
                      name="mac">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <fg-input class="primary" label="Asignar al usuario">
              <el-select
                class="select-primary"
                v-model="device.user"
                filterable
                remote
                reserve-keyword
                placeholder="Filtrar por nombre, email o cédula"
                :clearable="true"
                :remote-method="getUsers"
                :loading="loadingUsers">
                <el-option
                  v-for="item in users"
                  :key="item.user_id"
                  :label="item.user_name"
                  :value="item.user_id">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
            Actualizar Dispositivo
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
  import vueElementLoading from 'vue-element-loading'
  import swal from 'sweetalert2'
  import {EventBus} from '@/EventBus.js'
  import { Select, Option } from 'element-ui'
  export default {
    components: {
      vueElementLoading,
      swal,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data () {
      return {
        users:[],
        loadingUsers: false,
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        device:{
          user: '',
          brand: '',
          model: '',
          id_device:'',
          mac: ''
        },
        account: {},
        modelValidations: {
          id:{
            required: true
          },
          mac:{
            required: true,
            regex: /^([0-9a-fA-F]{2}[:]){5}([0-9a-fA-F]{2}){1}$/
          }
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          //this.$emit('on-submit', this.registerForm, isValid)
          if(isValid)
            this.addDevice();
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      getUsers (filter) {
        this.loadingUsers = true
        this.axios({
          url: `activatedusers/2?page=1&filter=${filter}`,
          method: 'get',
          headers: {
            authorization:localStorage.token
          }
        })
        .then(response => {
          console.log(response.data.data.user)
          this.loadingUsers = false
          this.users = response.data.data.user
        })
        .catch(error => {
          this.loadingUsers = false
        })
      },
      addDevice () {
        if(typeof this.device.user == "string" && this.device.user != ""){
          this.device.user = this.device.temp_id
        }

        this.loading.active = true
        this.device.id = this.$route.params.id
        this.axios({
          url: `editdevice`,
          method: 'put',
          data: this.device,
          headers: {
            authorization: localStorage.token
          }
        })
        .then(response => {
          this.loadData()
          this.loading.active = false
          this.showSwal('success', 'Dispositivo actualizado exitosamente')
        })
        .catch(error => {
          this.loading.active = false
          this.showSwal('error', error.response.data.message)
          console.log(error.response)
        })
      },
      loadData () {
        this.axios({
          url: `oneDevice/${this.$route.params.id}`,
          method: 'get',
          headers: {
            authorization: localStorage.token
          }
        })
        .then(response => {
          console.log(response)
          this.device = response.data.data.devices
          this.device.temp_id = response.data.data.devices.user
          this.device.user = response.data.data.devices.user_name
        })
        .catch(error => {
          console.log(error)
        })
      },
      showSwal (type, message) {
        if (type === 'success') {
            swal.fire({
              title: message,
              type: 'success'
            })
        } else if (type === 'error') {
            swal.fire({
              title: message,
              type: 'warning'
            })
        }
      },
      clearModel () {
        this.device = {
          brand: '',
          model: '',
          id_device:'',
          mac: ''
        }
      }
    },
    created () {
      this.account = JSON.parse(localStorage.account)
      this.loadData()
    }
  }

</script>
<style>
#edit_form label{
color: #777!important;
}
</style>
